
import AttachmentMixin from '@/_mixins/attachment'

export default {
    name: 'UserAvatar',
    mixins: [AttachmentMixin],
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    computed: {
        initials() {
            let initials = ''
            const words = this.user.name.split(/\s/)
            words.map((word, index) => {
                if (index == 0 || index == words.length - 1) {
                    initials += word.slice(0, 1).toUpperCase()
                }
            })
            return initials
        },
        avatar() {
            if (!this.user.avatarFileId) {
                return null
            }
            return this.getPreview(this.user.avatarFileId)
        },
    },
}
